import { toastService, toaster } from '@/lib/toastService'
import { Portal, Stack, Toast } from '@chakra-ui/react'
import { Toaster as ChakraToaster } from '@chakra-ui/react/toast'

/**
 * Toast Hook
 * Wrapper around toast service for use in React components
 * Uses the same toaster instance as toastService
 */
export function useToast() {
  return toastService
}

/**
 * Toaster Component
 * Renders toast notifications using Chakra UI Toaster
 */
export function Toaster() {
  return (
    <Portal>
      <ChakraToaster toaster={toaster}>
        {(toast) => (
          <Toast.Root width={{ base: 'full', md: 'sm' }}>
            {toast.type === 'loading' ? (
              <div style={{ fontSize: '20px' }}>⏳</div>
            ) : (
              <Toast.Indicator />
            )}
            <Stack gap={1} flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && (
                <Toast.Description>{toast.description}</Toast.Description>
              )}
            </Stack>
            <Toast.CloseTrigger />
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  )
}

export default useToast
